import { render, staticRenderFns } from "./AddPrivilegeModal.vue?vue&type=template&id=86b32716&scoped=true&"
import script from "./AddPrivilegeModal.vue?vue&type=script&lang=js&"
export * from "./AddPrivilegeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivilegeModal.vue?vue&type=style&index=0&id=86b32716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b32716",
  null
  
)

export default component.exports